import axios from "axios";

const BASE_URL = process.env.VUE_APP_SERVER_URL + "api/status";

class StatusService {
    async getStatus() {
        let result = null;
        await axios.get(`${BASE_URL}/getstatus`, {headers: {'Access-Control-Allow-Origin': '*',"Access-Control-Allow-Headers": "Content-Type, Authorization, X-Requested-With" }})
            .then((res) => {
                result = res;
            })
            .catch((err) => {
                window.alert(err.response.data.message)
            });
        return result;
    }
}

export default new StatusService;